import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {TtTravelEntry} from '../../interfaces/time-tracking/tt-travel-entry';
import {TtTravelEntryFactory} from '../../factories/time-tracking/tt-travel-entry-factory';


@Injectable({
  providedIn: 'root'
})
export class TtTravelEntriesTable extends SecureTable<TtTravelEntry> {

  constructor() {
    super(db.ttTravelEntries);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<TtTravelEntry>({
        api: ['tt-travel-entries'],
        fromObject: TtTravelEntryFactory.fromObject,
        toRemote: TtTravelEntryFactory.toRemote
      })
    };
  }
}
